import { Order, PageMeta, Sort } from "../public-types";

enum MemberStatus {
  MEMBER_INVITE = "MEMBER_INVITE",
  MEMBER_USE = "MEMBER_USE",
  MEMBER_DELETE = "MEMBER_DELETE",
  MEMBER_CLOSE = "MEMBER_CLOSE",
  MEMBER_EXPIRE = "MEMBER_EXPIRE",
}

interface Search {
  page?: number;
  size?: number;
  sort?: Sort;
  searchType?: string;
  searchValue?: string;
  memberStatus?: string;
  contractApplyNumber?: string;
  watchingCalendar?: boolean;
  partnerId?: string;
}

interface GetUSerListModel {
  data: {
    data: UserListModel[];
    meta: {
      pageMeta: PageMeta;
    };
  };
}

interface UserListModel {
  contractMemberId: number;
  contractManageId: number;
  contractApplyNumber: string;
  inviteMobileNumber: string;
  memberNo: string;
  isContractor: boolean;
  isAdmin: boolean;
  inviteDate: string;
  memberStatus: string;
  useTime: string;
  isDeleted: string;
  spaceProductId: string;
  spaceProductName: string;
  signUpTime: string;
  email: string; // 회원 이메일
  phoneNumber: string; // 회원 휴대폰 번호
  nickName: string; // 회원 닉네임

  inviteEmail: string; // 초대 이메일

  inviteExpireDays: number; // 	초대만료기한 일수
  inviteExpireDate: string; // 초대만료기한 일시
  invitationChannel: string; // 초대 경로  (Taap, Ctrl.room)

  isPhoneNumberVerified: boolean; // 휴대폰 번호 인증 여부
  isEmailVerified: boolean; // 이메일 인증 여부
  isWatchingCalendar: boolean; // 캘린더 연동 사용 여부
  joinedDate: string; // 회원인증
  status: string; // 회원 상태
  nickname: string; // 회원 닉네임
  secondaryNickname: string; // 회원 추가 닉네임
  inviteeMemberId: string; // 초대자 회원번호
  inviteeMemberNo: string; // 초대자 회원번호
}

interface UserInsertModel {
  inviteMobileNumber: string;
}

interface UserDetailContent {
  contractMemberId: number;
  inviteMobileNumber: string;
  memberNo: string;
  isContractor: boolean;
  isAdmin: boolean;
  inviteDate: string;
  memberStatus: string;
  useTime: number;
  isDeleted: boolean;
  isWatchingCalendar: boolean;
  inviteeMemberId?: string;
  contractId?: number | string;
  contractManageId?: number | string;
  invitationChannel?: string;
  inviteExpireDays?: number;
  inviteExpireDate?: string;
  inviteEmail?: string;
  isInviteEnable?: boolean; // 재초대 가능여부
  statusDate?: string;
}

interface UserDetailCtMember {
  contractId: number;
  memberNo: string;
  phoneNumber: string;
  email: string;
  nickname: string;
  secondaryNickname: string; // 추가 닉네임

  isPhoneNumberVerified: boolean;
  isEmailVerified: boolean;
  joinedDate: string;
  status: string;
  // AVAILABLE : 정상
  // LOCKED : 임시정지
  // WITHDRAWAL : 탈퇴완료
  // WITHDRAWAL_REQUESTED : 탈퇴요청

  isWatchingCalendar: boolean;
  isExistsIssues: boolean;
  isResolvable: boolean;
  issueOccurredDate: string;
}

interface UserDetailInvietee {
  inviteeMemberId: number;
  inviteeMemberNo: string;
  inviteeEmail: string;
  inviteePhoneNumber: string;
}

interface UserDetailModel {
  contractMember: UserDetailContent;
  ctMember: UserDetailCtMember;
  inviteeInfo: UserDetailInvietee;
}
export { MemberStatus };
export type { Search, UserListModel, UserInsertModel, UserDetailInvietee, UserDetailModel, GetUSerListModel };

export interface GetUsersParams {
  contractApplyNumber: string;
  memberStatus?: string;
  // TODO(BE): CCA40 searchType 확장 대기.
  //           이용자 ID / 신청번호 / 상품 ID 검색옵션 추가분의 확정 코드값을 백엔드와 대조할 것
  searchType?: string;
  searchValue?: string;
  watchingCalendar?: boolean;
  // 초대경로 (CTRL_ROOM: Ctrl.room 파트너 회원이 초대 / MOBILE_APP: Mobile App 에서 계약자·마스터가 초대)
  invitationChannel?: string;
  partnerId?: string;
  page?: number;
  size?: number;
  sort?: Sort;
  memberNo?: string; //회원번호
}

export interface GetIssueCountCalendar {
  contractManageId: number;
}

export interface GetIssueCountCalendarResponse {
  issueOccurredChannelsCount: number;
}

export interface AddUsersRequestBody {
  contractManageId: string;
  contractMemberList: {
    inviteMobileNumber?: string;
    inviteExpireDays?: number; //기본 3일
    inviteEmail?: string;
  }[];
}
